import type { ReactNode } from "react";
import { ArrowLeft, RefreshCw } from "lucide-react";
import { roleLabels } from "../../../../shared/labels/contracts";
import type { DirectoryEntry, RequestDetail } from "../../../../shared/labels/contracts";
import { dateTime } from "../ui-types";
import { LabelRecordHeader } from "./LabelRecordHeader";
import type { DetailTab } from "../ui-types";

type Props = {
  detail: RequestDetail;
  demo?: boolean;
  printerView?: boolean;
  tab: DetailTab;
  busy: boolean;
  canAssign: boolean;
  assignment: string;
  directory: DirectoryEntry[];
  onTab: (tab: DetailTab) => void;
  onAssignment: (id: string) => void;
  onAssign: () => void;
  onClose: () => void;
  onRefresh: () => void;
  children: ReactNode;
};

const tabs: { id: DetailTab; label: string }[] = [
  { id: "work", label: "İşlem" },
  { id: "history", label: "Geçmiş" },
  { id: "files", label: "Dosyalar" },
  { id: "notifications", label: "Bildirimler" },
  { id: "source", label: "Kaynak" },
];

export function DetailFrame({ detail, demo = false, printerView = false, tab, busy, canAssign, assignment, directory, onTab, onAssignment, onAssign, onClose, onRefresh, children }: Props) {
  return <section className="anl-detail" aria-label={detail.requestNo + " talep ayrıntısı"}>
    <div className="anl-detail-toolbar">
      <button type="button" className="anl-button is-text" disabled={busy} onClick={onClose}><ArrowLeft size={16} aria-hidden="true" />İş listesi</button>
      <button type="button" className="anl-button is-text" disabled={busy} onClick={onRefresh}><RefreshCw size={14} aria-hidden="true" />Yenile</button>
    </div>
    <LabelRecordHeader detail={detail} />
    {detail.qualityWarning ? <p className="anl-quality-warning"><strong>Kalite uyarısı:</strong> {detail.qualityWarning}</p> : null}
    {canAssign ? <form className="anl-assignment" onSubmit={(event) => { event.preventDefault(); onAssign(); }}>
      <label className="anl-field">Doğrulanmış satış sorumlusu<select disabled={busy} value={assignment} onChange={(event) => onAssignment(event.target.value)}><option value="">Kişi seçilmedi</option>{directory.filter((actor) => actor.roles.includes("sales")).map((actor) => <option key={actor.id} value={actor.id}>{actor.displayName}</option>)}</select></label>
      <button type="submit" className="anl-button" disabled={busy || !assignment || assignment === detail.salesUserId}>Atamayı kaydet</button>
      <span className="anl-muted">Kaynak Excel’deki adlar otomatik kullanıcı veya alıcı sayılmaz.</span>
    </form> : null}
    <nav className="anl-detail-tabs" aria-label="Talep ayrıntısı bölümleri">
      {tabs.filter(item => ["work", "history", "files"].includes(item.id)).map((item) => <button type="button" className="anl-tab" key={item.id} aria-pressed={tab === item.id} onClick={() => onTab(item.id)}>{item.label}{!demo && item.id === "notifications" && detail.notifications.some((job) => job.status === "failed" || job.status === "awaiting_mapping") ? " · işlem bekliyor" : ""}</button>)}
      {!printerView ? <details className="anl-detail-more"><summary>Diğer bilgiler</summary><div>{tabs.filter(item => ["notifications", "source"].includes(item.id)).map(item => <button type="button" className="anl-tab" key={item.id} aria-pressed={tab === item.id} onClick={() => onTab(item.id)}>{item.label}{!demo && item.id === "notifications" && detail.notifications.some(job => job.status === "failed" || job.status === "awaiting_mapping") ? " · işlem bekliyor" : ""}</button>)}</div></details> : null}
    </nav>
    <div className="anl-detail-content">{children}</div>
    <details className="anl-record-details"><summary>Kayıt bilgileri</summary><dl className="anl-context-grid">
      <div><dt>{detail.planRow ? "Plan" : "İş emri kaynağı"}</dt><dd>{detail.planReference}</dd></div><div><dt>Etiket / varyant</dt><dd>{detail.labelKind} · {detail.variantKey}</dd></div>
      <div><dt>Sorumlu</dt><dd>{roleLabels[detail.responsibleRole]}{detail.salesUserName && detail.responsibleRole === "sales" ? " · " + detail.salesUserName : ""}</dd></div>
      <div><dt>Son hareket</dt><dd>{dateTime(detail.updatedAt)} · kayıt v{detail.version}</dd></div>
    </dl></details>
  </section>;
}
